export default __webpack_public_path__ + "static/media/39.ed89d87b.png";